import { actionChannel, call, put, take, takeEvery } from "redux-saga/effects";
import { buffers } from "redux-saga";

import { PUT } from "../types/request.types";
import {
  ADD_PRODUCT,
  DELETE_MENU,
  DELETE_PRODUCT,
  PRE_ADD_PRODUCT,
  PRE_DELETE_MENU,
  PRE_DELETE_PRODUCT,
  PRE_REQUEST_ADD_PRODUCT,
  PRE_REQUEST_DELETE_PRODUCT,
  PRE_REQUEST_UPDATE_MENU,
  PRE_REQUEST_UPDATE_PRODUCT,
  PRE_UPDATE_MENU,
  PRE_UPDATE_PRODUCT,
  REQUESTS_ADD_PRODUCT_FINISHED,
  REQUESTS_DELETE_PRODUCT_FINISHED,
  REQUESTS_UPDATE_MENU_FINISHED,
  REQUESTS_UPDATE_PRODUCT_FINISHED,
  UPDATE_MENU,
  UPDATE_PRODUCT,
} from "../types/cart.types";
import { requestHandler } from "./fetcher.saga";

//ADDING PRODUCT
export function* preAddProduct() {
  while (true) {
    const action = yield take(PRE_ADD_PRODUCT);
    const product = action.payload;
    const order_id = window.sessionStorage.getItem("ORDER_ID");

    yield put({
      type: PRE_REQUEST_ADD_PRODUCT,
      body: {
        product,
        order_id,
      },
    });
    const { productAdded } = yield take(REQUESTS_ADD_PRODUCT_FINISHED);
    yield put({
      type: ADD_PRODUCT,
      response: productAdded.data.product,
    });
  }
}

export function* watchAddProduct() {
  const requestChan = yield actionChannel(
    PRE_REQUEST_ADD_PRODUCT,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);
    const addProduct = yield call(
      requestHandler,
      PUT,
      `order/${action.body.order_id}`,
      action.body.product
    );

    yield put({
      type: REQUESTS_ADD_PRODUCT_FINISHED,
      productAdded: addProduct,
    });
  }
}

//UPDATE PRODUCT
export function* preUpdateProduct() {
  while (true) {
    const action = yield take(PRE_UPDATE_PRODUCT);
    const product = action.payload;
    const oldUniqueId = action.oldUniqueId;
    const order_id = window.sessionStorage.getItem("ORDER_ID");

    yield put({
      type: PRE_REQUEST_UPDATE_PRODUCT,
      body: {
        product,
        oldUniqueId,
        order_id,
      },
    });
    const { productUpdated } = yield take(REQUESTS_UPDATE_PRODUCT_FINISHED);
    yield put({
      type: UPDATE_PRODUCT,
      response: { productUpdated: productUpdated.data.result, oldUniqueId },
    });
  }
}

export function* watchUpdateProduct() {
  const requestChan = yield actionChannel(
    PRE_REQUEST_UPDATE_PRODUCT,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);

    const updateProduct = yield call(
      requestHandler,
      PUT,
      `order/extra/${action.body.order_id}`,
      action.body.product
    );
    yield put({
      type: REQUESTS_UPDATE_PRODUCT_FINISHED,
      productUpdated: updateProduct,
    });
  }
}

//DELETE PRODUCT
export function* preDeleteProduct() {
  while (true) {
    const action = yield take(PRE_DELETE_PRODUCT);
    const product = action.payload;
    const order_id = window.sessionStorage.getItem("ORDER_ID");

    yield put({
      type: PRE_REQUEST_DELETE_PRODUCT,
      body: {
        product,
        order_id,
      },
    });

    const { productDeleted } = yield take(REQUESTS_DELETE_PRODUCT_FINISHED);
    yield put({
      type: DELETE_PRODUCT,
      response: productDeleted.data.product,
    });
  }
}

export function* watchDeleteProduct() {
  const requestChan = yield actionChannel(
    PRE_REQUEST_DELETE_PRODUCT,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);

    const deleteProduct = yield call(
      requestHandler,
      PUT,
      `order/${action.body.order_id}`,
      action.body.product
    );
    yield put({
      type: REQUESTS_DELETE_PRODUCT_FINISHED,
      productDeleted: deleteProduct,
    });
  }
}

//UPDATE MENU
export function* preUpdateMenu() {
  while (true) {
    const action = yield take(PRE_UPDATE_MENU);
    const menu = action.payload;
    const oldUniqueId = action.oldUniqueId;
    const order_id = window.sessionStorage.getItem("ORDER_ID");

    yield put({
      type: PRE_REQUEST_UPDATE_MENU,
      body: {
        menu,
        oldUniqueId,
        order_id,
      },
    });
    const { menuUpdated } = yield take(REQUESTS_UPDATE_MENU_FINISHED);
    yield put({
      type: UPDATE_MENU,
      response: {
        menuUpdated: menuUpdated.data.result,
        oldUniQId: oldUniqueId,
      },
    });
  }
}

export function* watchUpdateMenu() {
  const requestChan = yield actionChannel(
    PRE_REQUEST_UPDATE_MENU,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);

    const updateMenu = yield call(
      requestHandler,
      PUT,
      `order/menu/${action.body.order_id}`,
      action.body.menu
    );
    yield put({
      type: REQUESTS_UPDATE_MENU_FINISHED,
      menuUpdated: updateMenu,
    });
  }
}

export function* watchDeleteMenu() {
  yield takeEvery(PRE_DELETE_MENU, deleteMenu);
}

export function* deleteMenu(action) {
  const menu = action.payload;
  const order_id = window.sessionStorage.getItem("ORDER_ID");

  const menuRemoved = yield call(
    requestHandler,
    PUT,
    `order/remove/menu/${order_id}`,
    menu
  );

  yield put({
    type: DELETE_MENU,
    response: menuRemoved.data.result,
  });
}